import {
  getMonitorList,
  handleMonitorList,
  getGroupList,
  handleGroupList,
  getSpecialConfig,
  getMaintianConfigList,
  handMaintianConfigList,
  handleSpecialConfig,
  getMonitorEvenntList,
  getFastAlarmConfig,
  handleFastAlarmConfig,
  getMonitorReport,
  getCustomMonitorList,
  handleCustomMonitorList,
  getCounter,
  getEndpointAlarmCounter,
  changeAlarmMethod,
  handlePrometheusMonitorList,
  getPrometheusMonitorList,
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";
import ajax from "../../../api/ajax";  // 导入封装后的axios请求

const state = {};

const getters = {};

const actions = {
  async getCounterMethod ({commit}, params) {
    return getCounter(getUrl(params)).then(response => response)
  },
  async flushCounterMethod ({commit}, params) {
    return getCounter(getUrl(params)).then(response => response)
  },
  async getCustomMonitorListMethod ({commit}, params) {
    return getCustomMonitorList(getUrl(params)).then(response => response)
  },
  async getEndpointAlarmCounterMethod ({commit}, params) {
    return getEndpointAlarmCounter(getUrl(params)).then(response => response)
  },
  async changeAlarmMethodMethod ({commit}, params) {
    return changeAlarmMethod(params).then(response => response)
  },
  async handleCustomMonitorListMethod ({commit}, params) {
    ajax.defaults.timeout = 60000;
    return handleCustomMonitorList(params).then(response => response)
  },
  async getMonitorListMethod ({commit}, params) {
    return getMonitorList(getUrl(params)).then(response => response)
  },
  async requestMonitorListMethod ({commit}, params) {
    return handleMonitorList(params).then(response => response)
  },

  async getGroupConfigListMethod ({commit},params){
    return getGroupList(getUrl(params)).then(response => response)
  },

  async requestGroupConfigListMethod ({commit},params){
    return handleGroupList(params).then(response => response)
  },

  async getSpecialListMethod ({commit}, params ) {
    return getSpecialConfig(getUrl(params)).then(response => response)
  },
  async requestSpeicalListMethod ({commit}, params)  {
    return  handleSpecialConfig(params).then(response =>  response)
  },

  async getMaintianListMethod ({commit}, params ) {
    return getMaintianConfigList(getUrl(params)).then(response => response)
  },

  async requestMaintianListMethod ({commit}, params) {
    return handMaintianConfigList(params).then(response => response)
  },

  async getMonitorEventListMethod ({commit}, params) {
    return getMonitorEvenntList(getUrl(params)).then(response => response)
  },
  async getFastAlarmConfigMethod({commit},params){
    return getFastAlarmConfig(getUrl(params)).then(response => response)
  },
  async requestFastAlarmConfigMethod({commit},params){
    return handleFastAlarmConfig(params).then(response => response)
  },
  async requestGetMonitorReportMethod({commit},params){
    return getMonitorReport(getUrl(params)).then(response => response)
  },
  async getPrometheusMonitorListMethod ({commit}, params) {
    return getPrometheusMonitorList(getUrl(params)).then(response => response)
  },
  async requestPrometheusMonitorListMethod ({commit}, params) {
    return handlePrometheusMonitorList(params).then(response => response)
  }

  // async getAllUserInfo ({commit}, params) {
  //   return getAllUserInfo(getUrl(params)).then(response => response)
  // }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/monitor/monitor.js